import { Typography } from "antd"
import cls from "classnames"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"

import InfoTooltip from "../../../../../../../Components/InfoTooltip/InfoTooltip"
import Icon from "../../../../../../../Icon"
import { ACTIVITY_LABEL, TIMELINE_FALLBACK, TIMELINE_META } from "../../../constants/activityMeta"
import { buildDisputeLogs } from "../../../utils/disputeLogs"

import groupStyles from "../../group.module.less"
import tabStyles from "../detailsTab.module.less"
import styles from "./activityLog.module.less"

const { Text } = Typography

// TIMELINE_META tones are data values; map them to this module's marker classes.
const TONE_CLASS = {
  neutral: "toneNeutral",
  info: "toneInfo",
  success: "toneSuccess",
  danger: "toneDanger",
  warning: "toneWarning"
}

const TimelineItem = ({ type, label, date }) => {
  const meta = TIMELINE_META[type] || TIMELINE_FALLBACK
  return (
    <div className={cls(styles.item, styles[TONE_CLASS[meta.tone]])}>
      <span className={styles.marker}>
        <Icon type={meta.icon} />
      </span>
      <div className={styles.itemBody}>
        <div className={styles.itemLabel}>{label}</div>
        <div className={styles.itemDate}>{date}</div>
      </div>
    </div>
  )
}

// The dispute's history, always on screen (it replaced the old View-activity-log
// popup): the status lifecycle first, then who on the team did what.
const ActivityLog = ({ dispute, activity }) => {
  const { t } = useTranslation()
  const logs = buildDisputeLogs(dispute, t)

  return (
    <aside className={tabStyles.side}>
      <div className={groupStyles.group}>
        <div className={cls(groupStyles.groupLabel, styles.label)}>{t("Activity log")}</div>
        {logs.length ? (
          <div className={styles.timeline}>
            {logs.map((e) => (
              <TimelineItem key={e.key} type={e.type} label={e.label} date={e.date} />
            ))}
          </div>
        ) : (
          <Text type="secondary">{t("No activity yet.")}</Text>
        )}
      </div>
      {activity && activity.length ? (
        <div className={groupStyles.group}>
          <div className={cls(groupStyles.groupLabel, styles.label)}>
            {t("Activity")}
            <InfoTooltip
              title={t(
                "Who worked this dispute and when. Assignments, approvals, rejections, and reopens are timestamped for your team and ours."
              )}
            />
          </div>
          <div className={styles.timeline}>
            {activity.map((a, i) => (
              <TimelineItem
                key={i}
                type={a.action}
                label={t(ACTIVITY_LABEL[a.action] || a.action)}
                date={[a.actor, a.created ? dayjs(a.created).format("DD MMM YYYY, HH:mm") : null]
                  .filter(Boolean)
                  .join(" · ")}
              />
            ))}
          </div>
        </div>
      ) : null}
    </aside>
  )
}

export default ActivityLog
